<div
  #container
  class="iu-modal-background"
  [attr.data-cy-contentType]="contentType"
  [hidden]="!isModalDisplay"
  [ngClass]="{ hidden: !isModalDisplay }"
  [ngStyle]="
    angularStyle !== undefined && angularStyle['iu-modal-background'] ? angularStyle['iu-modal-background'] : ''
  "
  (contextmenu)="$event.preventDefault()"
  (mousedown)="initClose($event)"
  (touchstart)="initClose($event)">
  <div
    cdkDrag
    [cdkDragBoundary]="container"
    class="{{ 'iu-modal ' + modalClass }}"
    [ngStyle]="angularStyle !== undefined && angularStyle['iu-modal'] ? angularStyle['iu-modal'] : ''">
    <div
      cdkDragHandle
      [ngClass]="[title !== undefined && title !== null ? 'border' : '', 'iu-modal-header']"
      [ngStyle]="angularStyle !== undefined && angularStyle['iu-modal-header'] ? angularStyle['iu-modal-header'] : ''">
      <div class="close-cross" [ngStyle]="{ float: title !== undefined && title !== null ? 'unset' : 'right' }">
        <iu-button-ui
          btnType="default"
          class="btn-close"
          data-cy="modal-close-btn"
          icon="icon-close"
          [isStandalone]="true"
          (click)="close($event, true)" />
      </div>
      @if (title !== undefined && title !== null) {
        <div class="title">{{ title | translate }}</div>
      }
      @if (isLoading) {
        <p-progressBar [mode]="'indeterminate'" [showValue]="false" [styleClass]="'loading-progressbar'" [value]="0" />
      }
    </div>

    <div
      class="iu-modal-body"
      [ngStyle]="angularStyle !== undefined && angularStyle['iu-modal-body'] ? angularStyle['iu-modal-body'] : ''">
      <ng-content />
    </div>
    @if (hasCloseBtn || hasFooter) {
      <div
        class="iu-modal-footer"
        [ngStyle]="
          angularStyle !== undefined && angularStyle['iu-modal-footer'] ? angularStyle['iu-modal-footer'] : ''
        ">
        <ng-content select="[footer]" />
        @if (hasCloseBtn) {
          <button
            class="p-button p-button-secondary"
            icon="fa fa-ban"
            pButton
            type="button"
            label="{{ closeBtnLabel | translate }}"
            (click)="close($event, true)"></button>
        }
      </div>
    }
  </div>
</div>
